// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { OrderTypeMap } from '@shared/utils/Trading/OrderType';
// TODO. Refactor. App needs only 1 instance per order type.
// Rename. UGLY.
export class OrderTypeBase {
    constructor(orderEdit, modifyOrder) {
        // TODO. Rename. Synonymic names.
        this.orderEdit = orderEdit;
        this.modifyOrder = modifyOrder;
    }
    // TODO. Refactor.
    localizationKey() {
        return OrderTypeMap[this.id()];
    }
    // TODO. Refactor.
    id() {
        return undefined;
    }
    // TODO. Refactor. CheckSession.
    IsSupported(params) {
        return OrderTypeBase.IsSupported(this.id(), params.instrument, params.checkSession);
    }
    // TODO. Refactor.
    static IsSupported(orderTypeId, instrument, checkSession = undefined) {
        if (!instrument) {
            return false;
        }
        checkSession = checkSession === undefined ? true : !!checkSession;
        const route = instrument ? instrument.DataCache.Routes.getRouteByName(instrument.Route) : null;
        const isSupportedByRoute = !isNullOrUndefined(route) && route.IsAllowableOrderType(orderTypeId);
        const isSupportedBySession = !checkSession || instrument.IsAllowOrderType(orderTypeId);
        return isSupportedByRoute && isSupportedBySession;
    }
    // TODO. Rename.
    createOrderEditObject(data) {
        if (this.orderEdit) {
            return new this.orderEdit(data, this.id());
        }
        return null;
    }
    // TODO. Refactor. Rename. UGLY.
    createModifyOrderObject(data) {
        if (this.modifyOrder) {
            return new this.modifyOrder(data, this.id());
        }
        return null;
    }
    checkRuleForAccount(account, rule, instrument) {
        const dc = account ? account.DataCache : instrument ? instrument.DataCache : null;
        return dc.isAllowedForAccount(rule, account);
    }
}
